import { observer } from 'mobx-react';
import { IValidationGroup } from '../../../../../../../hooks/validation-group/validation-group-hook';
import ApiKeyField from '../fields/api-key-field/api-key-field';
import CustomerNumberField from '../fields/customer-number-field/customer-number-field';
import IntersoftCredentialsStore from '../../../../stores/credentials/shipping/intersoft-credentials-store';
import { FormFieldLine } from '../../../../../../../components/form-field-line/form-field-line';
import { Input } from '../../../../../../../components/inputs/input/input';

const ADDRESS_NOTE = 'Must match the posting location address registered with Royal Mail';

interface IProps {
    credentialsStore: IntersoftCredentialsStore,
    vGroup: IValidationGroup,
}

const IntersoftCredentials: React.FC<IProps> = observer(({
    credentialsStore,
    vGroup,
}) => {
    return (
        <>
            <CustomerNumberField
                credentialsStore={credentialsStore}
                validationGroup={vGroup}
                label='Royal Mail account number'
                note='Your Royal Mail account number'
            />
            <ApiKeyField
                credentialsStore={credentialsStore}
                validationGroup={vGroup}
                label='Royal Mail posting location'
                note='Posting location ID given by carrier'
            />
            <FormFieldLine
                required
                label='RM Email Address'
                key='email_address'
                note='RM account Email Address'
            >
                <Input
                    value={credentialsStore.emailAddress}
                    onChange={credentialsStore.setEmailAddress}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine
                required
                label='Posting location street address'
                key='address_line1'
                note={`Building number and street name, e.g. 10 Downing Street. ${ADDRESS_NOTE}`}
            >
                <Input
                    value={credentialsStore.addressLine1}
                    onChange={credentialsStore.setAddressLine1}
                    validationGroup={vGroup}
                    maxlength={40}
                    required
                />
            </FormFieldLine>
            <FormFieldLine
                required
                label='Town'
                key='town'
                note={`Town or city, e.g. London. ${ADDRESS_NOTE}`}
            >
                <Input
                    value={credentialsStore.town}
                    onChange={credentialsStore.setTown}
                    validationGroup={vGroup}
                    maxlength={40}
                    required
                />
            </FormFieldLine>
            <FormFieldLine
                required
                label='Postcode'
                key='postcode'
                note={`e.g. SW1A 2AA. ${ADDRESS_NOTE}`}
            >
                <Input
                    value={credentialsStore.postcode}
                    onChange={credentialsStore.setPostcode}
                    validationGroup={vGroup}
                    maxlength={10}
                    required
                />
            </FormFieldLine>
            <FormFieldLine
                required
                label='Country code'
                key='country_code'
                note={`Two-letter country code, e.g. GB. ${ADDRESS_NOTE}`}
            >
                <Input
                    value={credentialsStore.countryCode}
                    onChange={credentialsStore.setCountryCode}
                    validationGroup={vGroup}
                    minlength={2}
                    maxlength={2}
                    required
                />
            </FormFieldLine>
            <FormFieldLine
                required
                label='Contact name'
                key='contact_name'
                note='Contact name for the Royal Mail account'
            >
                <Input
                    value={credentialsStore.contactName}
                    onChange={credentialsStore.setContactName}
                    validationGroup={vGroup}
                    maxlength={35}
                    required
                />
            </FormFieldLine>
            <FormFieldLine
                required
                label='Contact phone'
                key='contact_phone'
                note='Contact phone for the Royal Mail account'
            >
                <Input
                    value={credentialsStore.contactPhone}
                    onChange={credentialsStore.setContactPhone}
                    validationGroup={vGroup}
                    maxlength={20}
                    required
                />
            </FormFieldLine>
        </>
    );
});

export default IntersoftCredentials;
